<template>
  <section class="home-service-content-sec" :class="isHomeTitle ? 'is-home-list' : ''">
    <div class="home-service-content-sec-title">
      <p>专业问题</p>
    </div>
    <div class="home-service-content-sec-content-article">
      <div class="home-service-content-sec-content-article-item" v-for="(item, index) in articleList" :key="index">
        <img :src="item.squareImgUrl" alt="">
        <router-link tag="div" :to="{name: 'article-detail', query: {id: item.id}}" class="home-service-content-sec-content-article-item-msg">
          <div class="home-service-content-sec-content-article-item-msg-title">
            <span v-if="item.type">{{item.type}}</span>{{item.title}}
          </div>
          <div class="home-service-content-sec-content-article-item-msg-paragraph">
            {{item.digest}}
          </div>
          <div class="home-service-content-sec-content-article-item-msg-detail">
            详情<Icon type="arrow-next" class="icon"></Icon>
          </div>
        </router-link>
      </div>
      <div class="home-service-content-sec-content-article-no" v-if="!articleList || !articleList.length">
        暂无相关文章
      </div>
    </div>
   <slot></slot>
  </section>
</template>

<script>
  import Icon from '@/common-components/icon'
  export default {
    name: 'article-list',
    components: { Icon },
    props: {
      articleList: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        isHomeTitle: false
      }
    },
    mounted () {
      if (this.$route.path === '/service' || this.$route.path === '/article') {
        this.isHomeTitle = true
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .is-home-list {
    .home-service-content-sec {
      &-title {
        height: .32rem !important
        p {
          height: .32rem !important
          font-size: .24rem !important
        }
      }
    }
  }
  .home-service-content-sec {
    margin-top .56rem
    &-title {
      display: flex
      justify-content space-between
      height: .5rem
      align-items center
      p {
        height: .5rem
        border-left .04rem solid #ed6c00
        font-size: .36rem
        padding-left .16rem
      }
    }
    &-content-article {
      margin-top .39rem
      &-item {
        display flex
        margin-top .16rem
        cursor pointer
        img {
          width: 2.2rem
          height: 1.65rem
          flex-shrink 0
        }
        &-msg {
          width: 7.2rem
          padding .24rem
          position relative
          background #fff
          cursor: pointer
          &-title {
            font-size: .18rem
            font-weight: 500
            line-height: .36rem
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap
            span {
              padding .05rem .12rem
              border-radius: 4px;
              background-color: #ffe9d2;
              font-size: .12rem
              color: #ed6c00;
              margin-right .08rem
              position: relative;
              bottom: .02rem;
            }
          }
          &-paragraph {
            font-size: .14rem
            color: #3e3a3a;
            line-height .22rem
          }
          &-detail {
            position absolute
            bottom .24rem
            right .24rem
            font-size: .18rem
            .icon {
              position relative
              top .03rem
              margin-left .1rem
            }
          }
        }
      }
      &-no {
        text-align center
        font-size: .24rem
        color #a9a9a9
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/common-components/article-list/article-list.vue